// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mrdw910 {
  padding-bottom: var(--_18w76bwg);
  padding-left: var(--_18w76bwg);
}
.mrdw911 {
  background-color: var(--_18w76bw25);
  padding: var(--_18w76bwd) var(--_18w76bw9) var(--_18w76bwt) var(--_18w76bw9);
  flex-direction: column;
  width: var(--_18w76bw1q);
  gap: var(--_18w76bwh);
  margin-left: auto;
  margin-right: auto;
}
.mrdw912 {
  flex-direction: column;
  background-color: var(--_18w76bw23);
}
.mrdw913 {
  padding: var(--_18w76bwg) var(--_18w76bwy);
  line-height: var(--_18w76bw44);
  border-bottom: 1px solid var(--_18w76bw28);
  width: var(--_18w76bw1u);
}
.mrdw914 {
  padding: var(--_18w76bwi) var(--_18w76bwy) var(--_18w76bw9);
  gap: var(--_18w76bwg);
  flex-direction: column;
}
.mrdw915 {
  padding-bottom: var(--_18w76bwl);
  border-bottom: 1px solid var(--_18w76bw28);
}
.mrdw916 {
  flex-direction: column;
  padding: var(--_18w76bwh) var(--_18w76bwy);
  gap: var(--_18w76bwg);
  width: var(--_18w76bw1u);
  margin-top: auto;
}
.mrdw917 {
  width: var(--_18w76bw1u);
}
.mrdw917:hover {
  text-decoration: none;
}
.mrdw917:focus {
  text-decoration: none;
}
@media screen and (max-width: 767px) {
  .mrdw911 {
    padding-top: var(--_18w76bw9);
    padding-bottom: var(--_18w76bwp);
    width: var(--_18w76bw1u);
    margin-left: var(--_18w76bw9);
    margin-right: var(--_18w76bw9);
    gap: var(--_18w76bwd);
  }
  .mrdw912 {
    padding: var(--_18w76bw9);
    height: var(--_18w76bw1t);
    margin: var(--_18w76bw9);
    width: var(--_18w76bw1u);
    min-height: var(--_18w76bw1t);
  }
  .mrdw913 {
    padding: var(--_18w76bwg);
  }
  .mrdw914 {
    padding: var(--_18w76bwh) var(--_18w76bwg) var(--_18w76bw9);
  }
  .mrdw915 {
    padding-bottom: var(--_18w76bwh);
  }
  .mrdw916 {
    padding: var(--_18w76bwh);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,mCAAmC;EACnC,4EAA4E;EAC5E,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,0CAA0C;EAC1C,8BAA8B;EAC9B,0CAA0C;EAC1C,wBAAwB;AAC1B;AACA;EACE,2DAA2D;EAC3D,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,6BAA6B;IAC7B,gCAAgC;IAChC,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;IACxB,wBAAwB;IACxB,6BAA6B;EAC/B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".mrdw910 {\n  padding-bottom: var(--_18w76bwg);\n  padding-left: var(--_18w76bwg);\n}\n.mrdw911 {\n  background-color: var(--_18w76bw25);\n  padding: var(--_18w76bwd) var(--_18w76bw9) var(--_18w76bwt) var(--_18w76bw9);\n  flex-direction: column;\n  width: var(--_18w76bw1q);\n  gap: var(--_18w76bwh);\n  margin-left: auto;\n  margin-right: auto;\n}\n.mrdw912 {\n  flex-direction: column;\n  background-color: var(--_18w76bw23);\n}\n.mrdw913 {\n  padding: var(--_18w76bwg) var(--_18w76bwy);\n  line-height: var(--_18w76bw44);\n  border-bottom: 1px solid var(--_18w76bw28);\n  width: var(--_18w76bw1u);\n}\n.mrdw914 {\n  padding: var(--_18w76bwi) var(--_18w76bwy) var(--_18w76bw9);\n  gap: var(--_18w76bwg);\n  flex-direction: column;\n}\n.mrdw915 {\n  padding-bottom: var(--_18w76bwl);\n  border-bottom: 1px solid var(--_18w76bw28);\n}\n.mrdw916 {\n  flex-direction: column;\n  padding: var(--_18w76bwh) var(--_18w76bwy);\n  gap: var(--_18w76bwg);\n  width: var(--_18w76bw1u);\n  margin-top: auto;\n}\n.mrdw917 {\n  width: var(--_18w76bw1u);\n}\n.mrdw917:hover {\n  text-decoration: none;\n}\n.mrdw917:focus {\n  text-decoration: none;\n}\n@media screen and (max-width: 767px) {\n  .mrdw911 {\n    padding-top: var(--_18w76bw9);\n    padding-bottom: var(--_18w76bwp);\n    width: var(--_18w76bw1u);\n    margin-left: var(--_18w76bw9);\n    margin-right: var(--_18w76bw9);\n    gap: var(--_18w76bwd);\n  }\n  .mrdw912 {\n    padding: var(--_18w76bw9);\n    height: var(--_18w76bw1t);\n    margin: var(--_18w76bw9);\n    width: var(--_18w76bw1u);\n    min-height: var(--_18w76bw1t);\n  }\n  .mrdw913 {\n    padding: var(--_18w76bwg);\n  }\n  .mrdw914 {\n    padding: var(--_18w76bwh) var(--_18w76bwg) var(--_18w76bw9);\n  }\n  .mrdw915 {\n    padding-bottom: var(--_18w76bwh);\n  }\n  .mrdw916 {\n    padding: var(--_18w76bwh);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
